import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { deviceStatus, sendTestPush } from "../../api/devices";
import { NeuButton } from "../../components/neu/Neu";

// إرسال إشعار تجريبي لكل أجهزة المستخدم المسجّلة.
export const PushTestButton = ({ reloadKey }) => {
  const { t } = useTranslation();
  const [state, setState] = useState({ push_enabled: false, devices: 0 });
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);

  useEffect(() => {
    deviceStatus().then(setState).catch(() => {});
  }, [reloadKey]);

  const send = async () => {
    setBusy(true);
    try {
      if (!state.push_enabled) {
        toast.error(t("push.testDisabled"));
        return;
      }
      if (!state.devices) {
        toast.error(t("push.testNoDevice"));
        return;
      }
      const res = await sendTestPush();
      setLast(res);
      if (res.sent) toast.success(t("push.testSent", { count: res.sent }));
      else if (res.reason === "fcm_not_configured") toast.error(t("push.testDisabled"));
      else if (res.reason === "fcm_rejected") toast.error(`${t("push.testRejected")} ${res.error || ""}`);
      else toast.error(t("push.testNoDevice"));
      setState((prev) => ({ ...prev, devices: Math.max(0, prev.devices - (res.removed || 0)) }));
    } catch (e) {
      setLast({ error: String(e?.message || e).slice(0, 140) });
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3 grid gap-2 sm:flex sm:flex-wrap sm:items-center sm:justify-between" data-testid="push-test-row">
      <p className="text-xs text-muted-foreground" data-testid="push-test-state">
        {state.push_enabled
          ? t("push.devices", { count: state.devices })
          : state.reason === "secret_key_mangled"
            ? t("push.keyMangled")
            : `${t("push.testDisabled")} (${state.reason || "unknown"})`}
      </p>
      <NeuButton
        variant="primary"
        className="flex w-full items-center justify-center gap-2 bg-emerald-500 py-2.5 text-xs sm:w-auto sm:px-5"
        disabled={busy}
        data-testid="push-test-btn"
        onClick={send}
      >
        <Send className="h-3.5 w-3.5" /> {t("push.test")}
      </NeuButton>
      {last ? (
        <pre className="col-span-full mt-1 overflow-x-auto rounded-xl bg-muted/40 p-2 text-[11px] leading-5 text-muted-foreground" dir="ltr" data-testid="push-test-diag">
          {`devices=${last.devices ?? "?"} · sent=${last.sent ?? 0} · removed=${last.removed ?? 0}`}
          {(last.fails || []).map((f) => `\n✗ ${f.platform}: ${f.status} ${f.reason}`).join("")}
          {last.error && !(last.fails || []).length ? `\n${last.error}` : ""}
        </pre>
      ) : null}
    </div>
  );
};
